import { useState } from "react";
import { Plus } from "lucide-react";
import { QuickEntrySheet } from "@/components/layout/QuickEntrySheet";

export const Fab = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="fab-quick-entry-button"
        aria-label="Lançamento rápido"
        onClick={() => setOpen(true)}
        className="fixed z-50 left-1/2 -translate-x-1/2 bottom-[calc(max(env(safe-area-inset-bottom),10px)+30px)] w-16 h-16 rounded-full bg-[var(--coral)] text-white shadow-[0_14px_28px_-10px_rgba(224,106,85,0.7)] flex items-center justify-center transition-transform active:scale-95 hover:scale-105"
      >
        <Plus size={30} strokeWidth={2.6} />
      </button>
      <QuickEntrySheet open={open} onOpenChange={setOpen} />
    </>
  );
};
